<template>
	<i :class="classes"></i>
</template>

<script>
export default {
	name: 'Icon',
	props: {
		size: {
			type: Number,
			validator(value) {
				return typeof value === 'number' && value === parseInt(value);
			}
		}
	},
	computed: {
		classes() {
			return (
				'icon mdi ' +
				(this.size
					? 'mdi-' + ['18', '24', '36', '48'][this.size] + 'px'
					: '') +
				' mdi-' +
				(this.$slots.default && this.$slots.default.length > 0
					? this.$slots.default[0].text
					: '')
			);
		}
	}
};
</script>
